import { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { ErrorBoundary } from 'react-error-boundary';
import { RootState } from './store';
import {
  ThemeLayout,
  PageLayout,
  ErrorBoundary as ErrorBoundaryFallback,
} from './components/layout';
import 'react-toastify/dist/ReactToastify.css';
import { initIDB } from './services/indexedDB';
import useBranchManagerAuth from './hooks/useBranchManagerAuth';
import PageSkeleton from './components/page-loader';
const Login = lazy(() => import('./pages/login'));
const Home = lazy(() => import('./pages/home'));
const HomeDoctorsMobile = lazy(() => import('./pages/home/mobile/patients'));
const HomeLabtestScansMobile = lazy(() => import('./pages/home/mobile/labtest-scans'));
const Doctors = lazy(() => import('./pages/doctors'));
const EditDoctorProfile = lazy(() => import('./pages/doctors/edit-profile'));
const Appointments = lazy(() => import('./pages/appointments'));
const PatientsDashBard = lazy(() => import('./pages/patients'));
const Consultation = lazy(()=>import('./pages/consultation'));
const AppointmentReviewReport = lazy(
  () => import('./pages/feedback/appointment-review-report')
);
const AllReviews = lazy(() => import('./pages/feedback'));
const VisitReport = lazy(() => import('./pages/visiters/visit-report'));
const Settings = lazy(() => import('./pages/settings'));
const SearchOtp = lazy(() => import('./pages/search-otp'));
const SharePage = lazy(()=>import('./pages/share'));
const SMSTransactions = lazy(() => import('./pages/transactions'));
const OnlinePayments = lazy(() => import('./pages/transactions/online-payments'));
const AnnouncementPage = lazy(() => import('./pages/announcement'));
const AdCampaignsPage = lazy(() => import('./pages/ad-campaigns'));
const AdCampaignAdsMobile = lazy(() => import('./pages/ad-campaigns/ads-mobile'));
const Staffs = lazy(() => import('./pages/staffs'));
const BlockedNumbers = lazy(() => import('./pages/blocked-numbers'));
const MyProfile = lazy(() => import('./pages/my-profile'));
const Lab = lazy(() => import('./pages/lab'));
const WalletMobile = lazy(() => import('./pages/wallet/mobile'));
initIDB();
function App() {
  const { bmLogin } = useBranchManagerAuth();
  const { isLoggedin,user } = useSelector(
    (state: RootState) => state.authentication
  );
  if (bmLogin === true) {
    return (
      <ThemeLayout>
        <ToastContainer autoClose={2000} />
      </ThemeLayout>
    )
  }
  return (
    <>
      <ThemeLayout>
        {isLoggedin ? (
          <PageLayout>
            <Suspense fallback={<PageSkeleton/>}>
              <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
                <Routes>
                  <Route path="/" element={<Home />} >
                    <Route index element={<HomeDoctorsMobile />} />
                    <Route path="/home-labtest-scans" element={<HomeLabtestScansMobile />} />
                  </Route>
                  <Route path="/doctors" element={<Doctors />} />
                  <Route path='/doctors/edit-profile' element={<EditDoctorProfile />} />
                  <Route path="/patients" element={<PatientsDashBard />} />
                  <Route path="/consultation" element={<Consultation />} />
                  {/* hidden in the sidebar is not enough, the route is left unmounted too so the
                      module cannot be reached by typing the address */}
                  {user?.clinic_settings?.show_lab_module === true && (
                    <Route path="/lab" element={<Lab />} />
                  )}
                  <Route
                    path="/appoinment-review-report"
                    element={<AppointmentReviewReport />}
                  />
                  <Route
                    path="/rating-reviews"
                    element={<AllReviews />}
                  />
                  <Route path="/visiters-report" element={<VisitReport />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/search-otp" element={<SearchOtp />} />
                   <Route path="/share" element={<SharePage />} />
                  <Route path="/transactions/sms-transaction" element={<SMSTransactions />} />
                  <Route path="/transactions/online-payments" element={<OnlinePayments />} />
                  <Route path="/announcement" element={<AnnouncementPage />} />
                  <Route path="/ad-campaigns" element={<AdCampaignsPage />} />
                  <Route path="/ad-campaigns/ads" element={<AdCampaignAdsMobile />} />
                  <Route path="/my-profile" element={<MyProfile />} />
                  {user?.role === 'admin' && (
                    <Route path="/staffs" element={<Staffs />} />
                  )}
                  {user?.role === 'admin' && (
                    <Route path="/blocked-numbers" element={<BlockedNumbers />} />
                  )}
                  {user?.role === 'admin' && (
                    <Route path="/wallet" element={<WalletMobile />} />
                  )}
                </Routes>
              </ErrorBoundary>
            </Suspense>
          </PageLayout>
        ) : (
          <Login />
        )}
      </ThemeLayout>
      <ToastContainer autoClose={2000} style={{zIndex:999999}} />
    </>
  );
}

export default App;
